<template>
  <div>
    <div class="table-header">
      <h3 class="table-title">{{ title }}</h3>
      <div v-if="editRate" class="edit-rate">
        EBITDA达成率：{{ editRate }}%
        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
          <div v-if="showEditRateBtn" class="edit-rate-btn" @click="editNum">
            <i class="el-icon-edit"></i>
          </div>
        </el-tooltip>
      </div>

      <div
        class="slash-badge"
        v-if="status||status==0"
        :style="{
          backgroundImage:
            'url(' + require(`@/assets/retail/${status}.png`) + ')',
        }"
      ></div>
    </div>
    <el-table
      :data="tableData"
      border
      size="medium"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      :summary-method="showSummary ? getSummaries : null"
      show-summary
      v-loading="tableLoading"
      height="calc(100vh - 230px)"
      ref="CommonTable"
    >
      <!-- 动态生成列 -->
      <template v-for="column in columns">
        <!-- 分组列 -->
        <el-table-column
          v-if="column.children"
          :key="column.label"
          :label="column.label"
          :align="column.align || 'center'"
          :min-width="column.minWidth"
          :width="column.width"
          :fixed="isPC ? column.fixed:false"
        >
          <el-table-column
            v-for="child in column.children"
            :key="child.prop"
            :prop="child.prop"
            :label="child.label"
            :align="child.align || 'center'"
            :min-width="child.minWidth"
            :width="child.width"
            :fixed="isPC ? column.fixed:false"
          >
            <template v-if="child.formatter" #default="{ row }">
              {{ child.formatter(row[child.prop]) }}
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 普通列 -->
        <el-table-column
          v-else
          :key="column.prop || column.label"
          :prop="column.prop"
          :label="column.label"
          :align="column.align || 'center'"
          :min-width="column.minWidth"
          :width="column.width"
          :fixed="isPC ? column.fixed:false"
          :type="column.type"
          show-overflow-tooltip
        >
          <template v-if="column.formatter" #default="{ row }">
            <span>{{ column.formatter(row[column.prop]) }}</span>
          </template>
        </el-table-column>
      </template>

      <!-- 操作列 -->
      <el-table-column v-if="showAction" label="操作" width="100" fixed="right">
        <template #default="{ row }">
          <el-button
            type="text"
            size="medium"
            @click="$emit('edit', row,'查看')"
            >查看</el-button
          >
          <el-button
            v-if="row.id != 0 && row.status==0"
            type="text"
            size="medium"
            @click="$emit('edit', row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { formatMoney } from "@/utils/tools";
export default {
  name: "CommonTable",
  props: {
    /**
     * 表格数据源
     * @type {Array}
     * @required
     * @example
     * [
     *   { name: '张三', department: '销售部', position: '经理' },
     *   { name: '李四', department: '市场部', position: '专员' }
     * ]
     */
    tableData: {
      type: Array,
      required: true,
    },

    /**
     * 表格列配置
     * @type {Array}
     * @required
     * @example
     * [
     *   { prop: 'name', label: '姓名', width: 100,children:[] },
     *   { prop: 'department', label: '部门', width: 120 }
     * ]
     */
    columns: {
      type: Array,
      required: true,
    },

    /**
     * 表格标题
     * @type {String}
     * @required
     * @example "2025年Q1运营人员提成汇总表"
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * 表格状态标识
     * @type {String}
     * @default ''
     * @description 用于控制状态标签的样式类名
     * @example "success" - 成功状态，显示绿色标签
     */

    /**
     * 状态显示对象
     * @type {string}
     * @default ''
     * @description 表格右上角显示的状态文本
     * @example "已确认"、"待审核"等
     */
    status: {
      type: [String, Number],
      default: null,
    },

    /**
     * EBITDA达成率显示文本
     * @type {String}
     * @default ''
     * @description 在支持部门长表格中显示的达成率文本
     * @example "EBITDA达成率：77%"
     */
    editRate: {
      type: [String, Number],
      default: "",
    },

    /**
     * 是否显示编辑达成率按钮
     * @type {Boolean}
     * @default false
     * @description 控制是否在达成率旁边显示编辑按钮
     */
    showEditRateBtn: {
      type: Boolean,
      default: false,
    },

    /**
     * 是否显示表格合计行
     * @type {Boolean}
     * @default true
     * @description 控制是否在表格底部显示合计行
     */
    showSummary: {
      type: Boolean,
      default: true,
    },

    /**
     * 是否显示操作列
     * @type {Boolean}
     * @default true
     * @description 控制是否在表格最右侧显示操作列(编辑按钮等)
     */
    showAction: {
      type: Boolean,
      default: true,
    },
    tableLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return{
     isPC: false
    }
  },

  updated() {
    this.refreshTable();
  },
  watch: {
    tableData: {
      handler(val) {
        this.refreshTable();
      },
      immediate: false,
      deep: true,
    },
  },
  mounted(){
    this.detectMobile();
    window.addEventListener("resize", this.detectMobile);
  },
  beforeDestroy(){
    window.removeEventListener("resize", this.detectMobile);
  },
  methods: {
    detectMobile(){
      this.isPC=window.innerWidth>=1240
      console.log("isPC",this.isPC,window.innerWidth);
      
    },
    refreshTable() {
      /*
 在表格内添加合计了合计行，根据业务多次调用数据渲染画面后，偶然导致画面变成如下图所示，table的数据行将合计行遮挡住了.
  原因：由于画面数据多次加载，导致表格渲染失败，element有个自带加载的方法doLayout，使用这个方法即可
*/
      this.$nextTick(() => {
        this.$refs.CommonTable.doLayout();
      });
    },
    editNum() {
      this.$prompt("请输入 EBITDA 达成率（%）", "编辑 EBITDA 达成率", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: this.editRate || "0",
        inputValidator: (value) => {
          if (!value) return "此项为必填项";
          if (!/^[1-9]\d*$/.test(value)) return "请输入有效的正整数（如：77）";
          return true;
        },
      })
        .then(({ value }) => {
          this.$emit("update:editRate", value);
          this.$emit("updateEbitda", { ebitda: value });
          this.$message.success(`EBITDA 达成率: ${value}%`);
        })
        .catch(() => {});
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 需要计算的字段列表
      const calculateFields = [
        "Q1提成工资",
        "Q1绩效",
        "应发(80%)",
        "剩余未发(20%)",
        "补发",
        "扣减",
        "应发",
      ];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计"; // 第一列显示"合计"
          return;
        }

        // 检查当前列是否需要计算
        if (calculateFields.includes(column.label || column.property)) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            const sum = values.reduce((prev, curr) => {
              const value = Number(curr);
              return !isNaN(value) ? prev + value : prev;
            }, 0);
            sums[index] = formatMoney(sum); // 添加单位
          } else {
            sums[index] = ""; // 非数字字段留空
          }
        } else {
          sums[index] = ""; // 不需要计算的字段留空
        }
      });

      return sums;
    },
    headerCellStyle() {
      return {
        background: "#ECFFF0",
        fontWeight: "bold",
        color: "#333",
        textAlign: "center",
        padding: "12px 0",
      };
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      const baseStyle = {
        padding: "12px 0",
        textAlign: "center",
        background: rowIndex % 2 === 0 ? "#fff" : "#F8FFFB",
      };

      return baseStyle;
    },
  },
};
</script>

<style scoped lang="scss">
/* 合计行整体样式修改开始 */
.el-table ::v-deep .el-table__footer-wrapper tbody td {
  color: #333;
  font-weight: bolder;
}
/* 合计行整体样式修改结束*/

.table-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border: 1px solid #eaeaea;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
  position: relative;
}

.table-title {
  font-weight: 600;
  //   margin: 0 auto;
}

.edit-rate {
  color: #d03400;
  background: #ffdddd;
  font-size: 24px;
  font-weight: normal;
  padding: 3px 30px;
  border-radius: 20px;
  margin-left: 40px;
  height: 100%;
}

.edit-rate-btn {
  margin-left: 10px;
  color: #964545;
  font-size: 22px;
  font-weight: normal;
  padding: 10px;
  border-radius: 10px;
  display: inline-block;
  cursor: pointer;
}

.slash-badge {
  // background-image: url("~@/assets/retail/1.png");  //通过status动态生成
  background-size: contain; /* 填充整个div */
  background-position: center; /* 图片居中 */
  background-repeat: no-repeat; /* 禁止重复 */
  width: 120px;
  height: 120px;
  position: absolute;
  right: 0;
  top: 0px;
  z-index: 10;
}
</style>
